<div class="table-responsive">
  <table class="table table-hover table-center custom-table">
    <thead>
      <tr>
        <th *ngFor="let header of headers; let i = index" class="custom-header" [ngClass]="{'rdv-header': header.label === 'Rendez-vous'}">
          {{ header.label }}
        </th>
        <th *ngIf="hasActions" class="text-center custom-header">Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="paiements && paiements.length > 0; else empty">
        <tr *ngFor="let paiement of paiements; let i = index">
          <!-- Dossier N° -->
          <td class="dossier-number">{{ paiement.patientRef || paiement.ref || '..' }}</td>
          
          <!-- Patient -->
          <td class="patient-cell">
            <div class="table-avatar">
              <a class="booking-doc-img">
                <img [src]="avatarSrc(paiement)" [alt]="paiement.patientFirstName + ' ' + paiement.patientLastName" />
              </a>
              <a (click)="onUpdateRequest.emit(paiement)" class="patient-name">
                {{ (paiement.patientFirstName || paiement.firstName) + ' ' + (paiement.patientLastName || paiement.lastName) }}
              </a>
            </div>
          </td>
          
          <!-- Rendez-vous -->
          <td class="rdv-cell">
            <span class="rdv-badge">{{ paiement.appointmentCount || 0 }}</span>
          </td>
          
          <!-- Consultation -->
          <td class="amount-cell consultation-amount">{{ paiement.regularConsultationAmounts | dashboradPaiement }}</td>
          
          <!-- Actes -->
          <td class="amount-cell actes-amount">{{ paiement.regularConsultationEntriesAmounts | dashboradPaiement }}</td>
          
          <!-- Total -->
          <td class="amount-cell total-amount">{{ (paiement.regularConsultationAmounts || 0) + (paiement.regularConsultationEntriesAmounts || 0) | dashboradPaiement }}</td>
          
          <!-- Payé -->
          <td class="amount-cell paid-amount">{{ paiement.paidAmounts | dashboradPaiement }}</td>
          
          <!-- Reste -->
          <td class="amount-cell" [ngStyle]="{ 'color': ((paiement.regularConsultationAmounts || 0) + (paiement.regularConsultationEntriesAmounts || 0) - (paiement.paidAmounts || 0)) < 0 ? 'green' : 'red' }">
            {{ ((paiement.regularConsultationAmounts || 0) + (paiement.regularConsultationEntriesAmounts || 0) - (paiement.paidAmounts || 0)) | dashboradPaiement }}
          </td>
          
     
        </tr>
      </ng-container>
      <ng-template #empty>
        <tr>
          <td [attr.colspan]="hasActions ? 9 : 8" class="empty-cell">
            {{ emptyMessage || 'Aucun paiement trouvé !' }}
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>

<app-pagination [pageRequest]="pageRequest" [refresh]="onRefresh" (content)="paiements = $event"></app-pagination>